import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/interhome.svg")